/**
 * Conversation turn factory and history shaping for RAG requests.
 */

export function makeEmptyTurn(question) {
  return {
    id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
    question,
    response: null,
    streamingAnswer: '',
    thinking: '',
    thinkingExpanded: true,
    referencesExpanded: false,
  };
}

/**
 * @param {Array<{ question: string, response?: { answer?: string } }>} conversation
 * @returns {Array<{ role: string, content: string }> | undefined}
 */
export function buildConversationHistory(conversation) {
  return conversation.length
    ? conversation.flatMap((t) => [
      { role: 'user', content: t.question },
      ...(t.response?.answer ? [{ role: 'assistant', content: t.response.answer }] : []),
    ])
    : undefined;
}
